export default __webpack_public_path__ + "assets/moon-waxing-gibbous.4e3333d2.svg";